import initNavigationSurPageImage from './../modules/surPageImage';
import initAos from './../aos';

const LOADER = `
    <div class="simple-page-loader-wrapper-inline">
        <svg
            class="simple-page-loader"
            width="100"
            viewBox="0 0 38 38"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#1c1c1c"
        >
            <g transform="translate(1 1)" stroke-width="1" fill="none" fill-rule="evenodd">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        </svg>
    </div>
`;

export default function initAccueil() {
    if (!document.querySelector('[data-onglet-switch]')) {
        return;
    }

    const ongletsSwitchers = document.querySelectorAll('[data-onglet-switch]');

    ongletsSwitchers.forEach((ongletSwitcher) => {
        ongletSwitcher.addEventListener('click', (e) => {
            e.preventDefault();

            const ongletSwitcherTarget = ongletSwitcher.getAttribute('data-onglet-switch');
            let url = window.location.href.replace('#', '');

            if (ongletSwitcherTarget === '#onglet-1') {
                url = url + '?onglet=1';
            }

            if (ongletSwitcherTarget === '#onglet-2') {
                url = url + '?onglet=2';
            }

            if (ongletSwitcherTarget === '#onglet-3') {
                url = url + '?onglet=3';
            }

            if (ongletSwitcherTarget === '#onglet-4') {
                url = url + '?onglet=4';
            }

            if (ongletSwitcherTarget === '#onglet-5') {
                url = url + '?onglet=5';
            }

            document.querySelector('[data-load-content]').innerHTML = LOADER;

            fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser();
                    const newDocument = parser.parseFromString(html, 'text/html');

                    const newContent = newDocument.querySelector('[data-load-content]').innerHTML;

                    document.querySelector('[data-load-content]').innerHTML = newContent;

                    setTimeout(() => {
                        initNavigationSurPageImage();
                        initAos();
                    }, 1000);
                });
        });
    });
}
